export enum OrthogonalDirection {
    Up,
    Down,
    North,
    East,
    South,
    West
}
